
import { API_ENDPOINTS } from '@/src/constants';
import { useAuth } from '@/src/contexts';
import { djangoClient } from '@/src/helpers';
import { useQuery } from '@tanstack/react-query';
import { TokenizedAssetPoolQueryKeys, TokenizedAssetPoolResponse } from './tokenized-asset-pool.types';

/**
 * Get all tokenized asset pools from the API
 * This provides mapping between Fireblocks asset IDs and XRPL token information
 */
export const useTokenizedAssetPools = () => {
  const { user } = useAuth();

  return useQuery({
    queryKey: [TokenizedAssetPoolQueryKeys.TokenizedAssetPools],
    queryFn: async () => {
      const response = await djangoClient.get<TokenizedAssetPoolResponse>(
        `${API_ENDPOINTS.TOKENIZED_ASSET_POOL}?format=json&is_active=true`
      );
      return response.data;
    },
    enabled: !!user?.email, // Only fetch when user is authenticated and email is available
    staleTime: 5 * 60 * 1000, // 5 minutes - asset pools don't change frequently
    gcTime: 10 * 60 * 1000, // 10 minutes cache
  });
};
